import { interpolate, P, SharedColors } from "apparatus/library/common";
import { Group, Path, PointText } from "paper";
const RED = "#e74141";
const TICK_EVERY_DEGREES = 22.5;
export class Compass {
    render(appearance) {
        const radius = appearance.size / 2;
        // Main circular body
        const body = new Path.Circle(P(0, 0), radius)
            .withStroke("default", SharedColors.stroke)
            .withFill("#eeeeee");
        // Inner decorative ring
        const innerRing = new Path.Circle(P(0, 0), radius - 6)
            .withStroke("thin", "#cccccc");
        // Cardinal points (N, E, S, W) and ticks
        const cardinalPoints = new Group();
        const textSize = interpolate(appearance.size, [50, 100], [5, 10]);
        const points = [
            { label: "N", angle: 0, color: RED },
            { label: "E", angle: 90, color: SharedColors.stroke },
            { label: "S", angle: 180, color: SharedColors.stroke },
            { label: "W", angle: 270, color: SharedColors.stroke },
        ];
        points.forEach(p => {
            const text = new PointText({
                point: P(0, -radius + textSize * 1.2 + 4).rotate(p.angle, P(0, 0)),
                content: p.label,
                fillColor: p.color,
                fontSize: textSize,
                fontWeight: "bold",
                fontFamily: "Rubik",
                justification: "center"
            });
            // Manual adjustment for vertical centering of text
            text.translate(P(0, textSize * 0.38));
            cardinalPoints.addChild(text);
        });
        // Small ticks every 10 degrees
        for (let i = 0; i < 360; i += TICK_EVERY_DEGREES) {
            const tick = new Path.Line(P(0, -radius + 6), P(0, -radius + 9))
                .withStroke(1, "#aaaaaa");
            tick.rotate(i, P(0, 0));
            cardinalPoints.addChild(tick);
        }
        // Rotatable needle
        const needleRadius = radius - 12;
        const needleHalfWidth = interpolate(appearance.size, [70, 100], [4, 6]);
        const centerPinRadius = Math.max(2, needleHalfWidth / 2);
        // North part (Red)
        const northNeedle = new Path([
            P(0, -needleRadius),
            P(needleHalfWidth, 0),
            P(-needleHalfWidth, 0)
        ]).close()
            .withFill(RED);
        // South part (White)
        const southNeedle = new Path([
            P(0, needleRadius),
            P(needleHalfWidth, 0),
            P(-needleHalfWidth, 0)
        ]).close()
            .withFill("white");
        // Single continuous outline for the whole needle
        const needleOutline = new Path([
            P(0, -needleRadius),
            P(needleHalfWidth, 0),
            P(0, needleRadius),
            P(-needleHalfWidth, 0)
        ]).close()
            .withStroke("thin", SharedColors.stroke);
        const needle = new Group([northNeedle, southNeedle, needleOutline]);
        needle.rotate(appearance.needleAngle, P(0, 0));
        // Center pin / pivot
        const centerPin = new Path.Circle(P(0, 0), centerPinRadius)
            .withFill("#555555");
        const graphic = new Group([body, innerRing, cardinalPoints, needle, centerPin]);
        return {
            graphic,
            hitShape: body.bounds.toShape()
        };
    }
}
Compass.properties = {
    label: "Compass",
    defaultAppearance: {
        size: 80,
        needleAngle: 33,
    },
    appearanceSpecs: [
        {
            spec: "slider", key: "size", label: "props.Size",
            min: 70, max: 150, step: 1, unit: "mm",
        },
        {
            spec: "slider", key: "needleAngle", label: "props.Angle",
            min: 0, max: 360, step: 1, pipsStep: 90, unit: "°",
        },
    ],
};
